export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Disabled = 'DISABLED',
  Revoked = 'REVOKED'
}
